/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH
 * @see PROJECT_LICENSE.txt
 */

const liveSearchGender = {
    toggleActiveGenderLabel: null,
    initGender() {
        if (!Alpine.store("genderToggle")) return;

        Alpine.store("genderToggle").checked = hyva.getCookie("mey-gender") === "m";
        this.toggleActiveGenderLabel = this.getActiveGenderLabel();
    },
    getActiveGenderLabel() {
        return Alpine.store("genderToggle").checked
            ? this.genderLabels.men
            : this.genderLabels.women;
    },
    toggleGender() {
        Alpine.store("genderToggle").used = true;
        this.resetFacets();
        this.resetProducts();
        this.getProducts("gender", 1);
    }
};

export default liveSearchGender;
